import base from "/app/images/pause.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");